module.exports = __webpack_public_path__ + "img/软著.b8c8705a.png";